// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MergeClientProfilesMutationVariables = Types.Exact<{
  input: Types.MergeClientProfilesInput;
}>;


export type MergeClientProfilesMutation = { __typename?: 'Mutation', mergeClientProfiles: { __typename?: 'ClientProfile', id: string } };

export const Operations = {
  Mutation: {
    MergeClientProfiles: 'MergeClientProfiles' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const MergeClientProfilesDocument = gql`
    mutation MergeClientProfiles($input: MergeClientProfilesInput!) {
  mergeClientProfiles(input: $input) {
    id
  }
}
    `;
export type MergeClientProfilesMutationFn = Apollo.MutationFunction<MergeClientProfilesMutation, MergeClientProfilesMutationVariables>;

/**
 * __useMergeClientProfilesMutation__
 *
 * To run a mutation, you first call `useMergeClientProfilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeClientProfilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeClientProfilesMutation, { data, loading, error }] = useMergeClientProfilesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergeClientProfilesMutation(baseOptions?: Apollo.MutationHookOptions<MergeClientProfilesMutation, MergeClientProfilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeClientProfilesMutation, MergeClientProfilesMutationVariables>(MergeClientProfilesDocument, options);
      }
export type MergeClientProfilesMutationHookResult = ReturnType<typeof useMergeClientProfilesMutation>;
export type MergeClientProfilesMutationResult = Apollo.MutationResult<MergeClientProfilesMutation>;
export type MergeClientProfilesMutationOptions = Apollo.BaseMutationOptions<MergeClientProfilesMutation, MergeClientProfilesMutationVariables>;